import {NgModule} from "@angular/core";
import {AksjeklasseRedigerListeKomponentAvhengigheter} from "web-ng2/moduler/aksjeklasse/komponenter/aksjeklasse-rediger-liste/aksjeklasse-rediger-liste";
import {AksjeklasseKomponentAvhengigheter} from "./komponenter/aksjeklasser/aksjeklasser";

@NgModule({
    providers: [
        AksjeklasseKomponentAvhengigheter,
        AksjeklasseRedigerListeKomponentAvhengigheter
    ]
})
export class AksjeklasseModul {

}
